<template>
    <v-content>
        <v-container fluid grid-list-lg>
            <v-layout row wrap>
                <v-flex v-if="matches && matches[0]" xs6>
                    <v-card color="blue-grey darken-1" class="white--text">
                        <v-card-title primary-title>
                            <div>
                                <h3 class="headline mb-0">{{matches[0].hometeam}} vs {{matches[0].description}}
                                    ({{matches[0].date.toDate().toLocaleDateString('nl-BE')}})</h3>
                                <div>{{matches[0].places - (matches[0].placesSold || 0) - (matches[0].type === 'regular' ? getTotalSubscriptions : 0)}} aantal plaatsen vrij!
                                    {{matches[0].placesSold || 0}} plaatsen verkocht.
                                    <template v-if="matches[0].type === 'regular'">{{getTotalSubscriptions}} plaatsen gereserveerd.</template>
                                </div>
                            </div>
                        </v-card-title>
                        <v-card-actions>
                            <router-link :to="{ name: 'match', params: { id: matches[0]['.key'] }}">
                                <v-btn flat dark>Tickets</v-btn>
                            </router-link>
                            <v-btn flat dark @click="editMatch(matches[0])">Bewerken</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
                <v-flex v-if="lastMatch && lastMatch[0]" xs6>
                    <v-card color="blue-grey darken-1" class="white--text">
                        <v-card-title primary-title>
                            <div>
                                <h3 class="headline mb-0">{{lastMatch[0].description}}
                                    ({{lastMatch[0].date.toDate().toLocaleDateString('nl-BE')}})</h3>
                                <div>{{lastMatch[0].placesSold || 0}} plaatsen verkocht.</div>
                            </div>
                        </v-card-title>
                        <v-card-actions v-if="lastMatch[0]['.key']">
                            <router-link :to="{ name: 'report', params: { id: lastMatch[0]['.key'] }}">
                                <v-btn flat dark>Rapport</v-btn>
                            </router-link>
                        </v-card-actions>
                    </v-card>
                </v-flex>
                <template v-for="match in matches.slice(1)">
                    <v-flex v-bind:key="match['.key']" xs12>
                        <v-card color="blue-grey darken-2" class="white--text">
                            <v-card-title primary-title>
                                <div>
                                    <h3 class="headline mb-0">{{ match.description }}
                                        ({{match.date.toDate().toLocaleDateString('nl-BE')}})</h3>
                                    <div>{{match.places - (match.placesSold || 0) - (match.type === 'regular' ? getTotalSubscriptions : 0)}} aantal plaatsen vrij.
                                        <template v-if="match.type === 'regular'">{{getTotalSubscriptions}} plaatsen gereserveerd.</template>
                                    </div>
                                </div>
                            </v-card-title>
                            <v-card-actions>
                                <router-link :to="{ name: 'match', params: { id: match['.key'] }}">
                                    <v-btn flat dark>Tickets</v-btn>
                                </router-link>
                                <v-btn flat dark @click="editMatch(match)">Bewerken</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </template>
            </v-layout>
        </v-container>
        <v-btn
                fab
                bottom
                right
                color="pink"
                dark
                fixed
                @click.stop="dialog = !dialog"
        >
            <v-icon>add</v-icon>
        </v-btn>
        <MatchDialog :dialog="dialog" v-on:closeDialog="dialog = false" :match-dates="getMatchDates" :selectedMatch="selectedMatch"/>
    </v-content>
</template>

<script>
import { db } from "../../firebase";
import MatchDialog from "../components/MatchDialog";
import dateFormat from "dateformat";

export default {
  components: { MatchDialog },
  name: "Dashboard",
  props: {
    msg: String
  },
  data() {
    return {
      matches: [],
      lastMatch: [],
      dialog: false,
      selectedMatch: null,
      subscriptionReports: []
    };
  },
  firestore() {
    const today = new Date();
    let yesterday = new Date();
    yesterday.setDate(today.getDate() - 1);

    return {
      matches: db
        .collection("matches")
        .where("date", ">", yesterday)
        .orderBy("date")
        .limit(5),
      lastMatch: db
        .collection("matches")
        .where("date", "<", today)
        .orderBy("date", "desc")
        .limit(1),
      subscriptionReports: db
        .collection("subscription-reports")
        .orderBy("year")
        .limit(1)
    };
  },
  computed: {
    getMatchDates: function() {
      const returnArray = [];
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.matches.forEach(match => {
        returnArray.push(
          returnArray.push(dateFormat(match.date.toDate(), "isoDate"))
        );
      });

      return returnArray;
    },
    getTotalSubscriptions: function() {
      if (this.subscriptionReports && this.subscriptionReports[0]) {
        return this.subscriptionReports[0].totals.originalTotalSubscriptions;
      }

      return 0;
    }
  },
  methods: {
    deleteMatch: function(match) {
      this.$firestore.matches.doc(match[".key"]).delete();
    },
    editMatch: function(match) {
      this.selectedMatch = match;
      this.dialog = !this.dialog;
    }
  }
};
</script>
